exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{min-width:0}.ui.header .sub.header.meta,body{color:#333}#wrapper{max-width:978px;margin:0 auto}.ui.vertical.segment:first-child{padding-top:0}.ui.small.list{font-size:1em}i.icon,i.icons{font-size:1.25em}.ui.list>.item>i.icon{padding-top:.1em}.ui.tiny.statistics .statistic>.label,.usstate .label{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;margin-top:.25rem;color:rgba(0,0,0,.6)}.ui.small.list{color:rgba(0,0,0,.6)}@media screen and (max-width:330px){.ui.tiny.statistics .statistic>.label,.usstate .label{font-size:.85em!important}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/styles/App.css
 ** module id = 166
 ** module chunks = 0
 **/